import type * as React from "react";
import useMediaQuery from "../../../common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";

interface MountingManagerTabProps {
  mountingManagerURL: string;
}

const MountingManagerTab: React.FC<MountingManagerTabProps> = (props) => {
  const { mountingManagerURL } = props;
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return (
    <div className={isDesktop ? undefined : "w-100"}>
      <iframe className="scha__pdp-iframe" id="mmIframe" src={mountingManagerURL} scrolling="yes" />
    </div>
  );
};

export default MountingManagerTab;
